(function(){
'use strict';

/**
 * @kind service
 * @name scAddressInterpretService
 *
 * @description
 * Interprets Google Places API address_components into a standardized address object.
 * Handles country-specific city type logic.
 */

function scAddressInterpretService() {
  /**
   * Gets the default city types for a given country.
   * @param {string} country - Country code (e.g., 'US', 'BR', 'GB')
   * @returns {Array<string>} Array of Google Places API city type strings
   */
  this.getCityTypesForCountry = function (country) {
    if (country === 'US') {
      return ['administrative_area_level_5', 'administrative_area_level_4', 'administrative_area_level_3', 'sublocality_level_1', // relevant to cities like NYC, ex: Brooklyn, Staten Island
      'locality'];
    } else {
      return ['administrative_area_level_5', 'administrative_area_level_4', 'administrative_area_level_3', 'administrative_area_level_2', // In Brazil, for example, this is the city (county in US)
      'postal_town', // In the UK, this is the city. no U.S. equivalent
      'locality'];
    }
  };

  /**
   * Interprets Google Places address_components into a standardized address object.
   * @param {Object} place - Google Places place object with address_components array
   * @param {Array<string>} [cityTypes] - Optional array of additional city types to append to default types
   * @returns {Object} Interpreted address object
   */
  this.interpret = function (place, cityTypes) {
    if (!place || !place.address_components) {
      return {
        subpremise: '',
        number: '',
        street: '',
        city: '',
        state: '',
        country: '',
        postalCode: '',
        postalCodeSuffix: ''
      };
    }

    var interpreted = {
      subpremise: '',
      number: '',
      street: '',
      city: '',
      state: '',
      country: '',
      postalCode: '',
      postalCodeSuffix: ''
    };

    // Find the country first, as it helps determine how we should identify the city.
    var country = '';
    _.forEach(place.address_components, function (component) {
      if (component.types.indexOf('country') > -1) {
        country = component.short_name;
      }
    });

    // Determine city types based on country, and append any additional types if provided
    var cityTypesArray = this.getCityTypesForCountry(country);
    if (cityTypes && Array.isArray(cityTypes)) {
      cityTypesArray = cityTypesArray.concat(cityTypes);
    }

    // Map Google Places types to our address fields
    // Best option should be last (for city, we try multiple types in order)
    var types = {
      subpremise: ['subpremise'],
      number: ['street_number'],
      street: ['route'],
      city: cityTypesArray,
      state: ['administrative_area_level_1'],
      country: ['country'],
      postalCode: ['postal_code'],
      postalCodeSuffix: ['postal_code_suffix']
    };

    // Extract address components
    _.forEach(types, function (typeArray, fieldName) {
      _.forEach(typeArray, function (typeLabel) {
        _.forEach(place.address_components, function (component) {
          if (component.types.indexOf(typeLabel) > -1) {
            // Use short_name for country and state, long_name for others
            if (fieldName === 'country' || fieldName === 'state') {
              interpreted[fieldName] = component.short_name;
            } else {
              interpreted[fieldName] = component.long_name;
            }
          }
        });
      });
    });

    return interpreted;
  };
}

angular.module('classy').service('scAddressInterpretService', scAddressInterpretService);
})();